module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"administration":"Administration","ends":"endet {value}","legal":"Impressum","menu":"Menü","privacyPolicy":"Datenschutz"},"en":{"administration":"Administration","ends":"ends {value}","legal":"Legal","menu":"Menu","privacyPolicy":"Privacy policy"}}')
  delete Component.options._Ctor
}
